__webpack_require__.p = "/bankconnect/";